import type { CountryCode, RegionCode } from '@/graphql/api'

export const regionRepresentingCountry: Record<RegionCode, CountryCode> = {
    INT: 'ZW',
    US: 'US',
    UK: 'GB',
    EU: 'BG',
    IE: 'IE',
    NZ: 'NZ',
    AU: 'AU',
    CA: 'CA',
    ZA: 'ZA',
}

export function getCountryFromRegionCode(regionCode: RegionCode): CountryCode {
    return regionRepresentingCountry[regionCode]
}

export function getRegionCodeForCountry(
    countryCode: CountryCode
): RegionCode | undefined {
    return Object.entries(regionRepresentingCountry).find(
        ([, country]) => country === countryCode
    )?.[0] as RegionCode | undefined
}
